export const buttonStyle = {
  default: 'btn-outline-info',
  positive: 'btn-outline-success',
  warning: 'btn-outline-primary',
  danger: 'btn-outline-danger',
}